import { useState } from 'react';

import NextImage from 'next/image';

import { USStateObject } from '../../constants/USstates/constants';
import { DEFAULT_US_STATE, US_STATES } from '../../constants/USstates/states';
import { Heading } from '../Heading/Heading';
import { SearchUSStateFromList } from '../Search/SearchUSStateFromList/SearchUSStateFromList';

import { SpeciesLinks } from './components/SpeciesLinks';
import { IAllStateSpeciesData } from './helpers/buildStateDataSpecies';

interface IProps {
  stateSpeciesData: IAllStateSpeciesData;
}

export const FindUSSpecies = ({ stateSpeciesData }: IProps) => {
  const [selectedState, setSelectedState] = useState<USStateObject>(DEFAULT_US_STATE);
  return (
    <div className="my-sm mx-8 flex max-w-[900px] flex-col items-center sm:mx-auto sm:w-2/3">
      <Heading variant="sm" as="h2" className="max-w-[440px] pb-2 text-center sm:pb-4">
        Check out the most popular species in your state
      </Heading>

      <SearchUSStateFromList setSelectedState={setSelectedState} />

      <div className="mt-5 flex size-full flex-col sm:flex-row">
        <div className="mt-1 flex w-full items-center justify-center sm:mt-0 sm:w-1/2">
          <NextImage
            sizes="(min-width: 600px) 50vw, 60vw"
            src={selectedState.svgGray.src}
            alt={selectedState.stateName}
            width={125}
            height={75}
          />
        </div>

        {US_STATES.map(state => {
          const stateSpeciesList = stateSpeciesData.allStateSpeciesData.find(
            stateDataObj => stateDataObj.stateID === state.stateID,
          );
          return (
            <SpeciesLinks
              key={state.stateID}
              selectedState={state}
              stateSpeciesList={stateSpeciesList}
              className={state.stateID === selectedState.stateID ? 'block' : 'hidden'}
            />
          );
        })}
      </div>
    </div>
  );
};
